import BaseModel from "../base/BaseModel.model";
import { PorposalModality } from "@/enums/PorposalModality";
import { PorposalExpectedResult } from "@/enums/PorposalExpectedResult";
import ProposalMember from "./porposalMembers.model";
import ProposalDocument from "./proposalDocument.Model";
import ProposedConsortium from "./proposedConsortium.Model";
import PorposalBudgetItem from "./porposalBudgetItem.model";
import Coin from './coin.Model';
import FieldArea from '../coding/fieldArea/fieldAreaModel';
import ResearchLine from '../coding/researchLine/researchLine.model';
import ResearchCenter from '../research/ResearchCenter/reseachCenter.model';
import User from '../security/user.model';

import UserWithoutCode from '@/models/userWithoutCode.Model';
import MultipleWaitinResult from './MultipleWaitinResult.model';
import { ProposalState } from '@/enums/ProposalState';
import ProposalMovements from './proposalMovements.model';
import ProporsalUsersEvaluators from './proporsalUsersEvaluators.Model';
import ProposalUserReport from './porposalUserReport.model';
import Area from '../coding/areaModel';
import PorposalMemberEffort from './porposalMemberEffort.model';
import { ProjectState } from '@/enums/projectState';
import ProposalScheduleGanttPhase from './proposalScheduleGanttPhase.model';
import ProjectType from './sendedPorposal.Model';
import PorposalProjectType from './porposalProjectType.model';
import ProposalHistoricPercentDoneScheduleGantt from './proposalHistoricPercentDoneScheduleGantt.model';
import EspecificObjective from './especificObjective.model';
export default class Porposal extends BaseModel {
  public name?: string;
  public code?: string;
  public codeProjectInExecution?: string;
  public annoucementId?: number;
  public projectTypeId?: number | null;
  public proposalArticulatedResearchCenter?: ResearchCenter | null;
  public proposalArticulatedInvestigador?: User | null;
  public areaId?: number | null;
  public areaFondocytId?: number | null;
  public area?: Area | null;
  public fieldAreaId?: number | null;
  public fieldAreaFondocytId?: number | null;
  public facultyId?: number | null;
  public fieldArea?: FieldArea | null;
  public researchLineId?: number | null;
  public researchLineFondocytId?: number | null;
  public documentContratId?: number | null;
  public isPatente?: Boolean | any;
  public isPublicacionesVista?: Boolean | any;
  public isOtrasPublicaciones?: Boolean  | any;
  public isOtros?: Boolean  | any;
  public hasFondocytNotification?: Boolean  | any;
  public isOpenProject?: Boolean  | any;

  public researchLine?: ResearchLine | null;
  public researchLineDescription?: string | null;
  public termsAndConditionsDescription?: string | null;
  public resolveAnyProblem?: boolean;
  public isInternactionalCompany?:boolean;
  public researchLineOrInnovationType?: string | null;
  public modality?: PorposalModality | null;
  public expectedResult?: PorposalExpectedResult | null;
  public startDate?: Date | null;
  public endDate?: Date | null = null;
  public sendDateToIES?: Date | null = null;
  public sendDateToFondocyt?: Date | null = null;
  public periodMonth?: number | null;
  public researchCenterId?: number | null;
  public aportFondocyt?: number = 0;
  public aportContrapartida?: number = 0;
  public totalBudget?: number = 0;
  public totalBudgetInvestigator?: number = 0;
  public fondocytContributionInvestigator?: number = 0;
  
  public executiveSummary?: string = "";
  public abstract?: string | null;
  public introduction?: string | null;
  public researchProblem?: string | null;
  public objetives?: string | null;
  public specificGoal?:string | null;
  public justification?: string | null;
  public background?: string | null;
  public stateOfTheArt?: string | null;
  public description?: string | null;
  public researchQuestions?: string | null;
  public hypothesis?: string | null;
  public facultyName?: string | null;

  public areaFondocytDescription?: string | null;
  public fieldAreaFondocytDescription?: string | null;
  public researchLineFondocytDescription?: string | null;

  public methodsAndMaterials?: string | null;
  public institutionDescription?: string | null;
  public personalInvolveProposal?: string | null;
  public otherActors?: string | null;
  public bibliography?: string | null;
  public porposalMembers: Array<ProposalMember> = [];
  public porposalUsersReports: Array<ProposalUserReport> = [];
  public technicalScientistObservation?:string = '';
  public financialCharacterObservation?:string = '';
  public proposedConsortiums: Array<ProposedConsortium> = [];
  public userWithoutCodes: Array<UserWithoutCode> = [];
  public multipleWaitinResult?: MultipleWaitinResult  | null = new MultipleWaitinResult();
  public proposalDocuments : Array<ProposalDocument> = [];
  public especificObjectives : Array<EspecificObjective> = [];
  public proposalHistoricPercentDoneScheduleGantt : Array<ProposalHistoricPercentDoneScheduleGantt> = [];
  public proposalScheduleGanttPhases:Array<ProposalScheduleGanttPhase> = [];
  public porposalProjectTypes:Array<PorposalProjectType> = [];
  public proposalArticulatedResearchCenterId?: number;
  public proposalArticulatedInvestigadorId?: number;
  public proposalArticulatedDescripction?: string | null;
  public proposalArticulatedPosibleName?: string | null;
  public userThatExcedTheCondition?:Array<any> | null;

  public coinId?: number;
  public coin?: Coin | null = new Coin();
  public aportFondocytBind?: string;
  public aportContrapartidaBind?: string;
  public proposedConsortiumId?: number;
  public porposalBudgetItems: Array<PorposalBudgetItem> = [];
  public proposalMovements: Array<ProposalMovements> = [];
  public proporsalUsersEvaluators: Array<ProporsalUsersEvaluators> = [];

  public currentProposalState: string = null;
  public tradeNumber: string = null;
  public requestBypassDateNumber: string = null;
  public deliveryDateNumber: string = null;
  
  public researchCenter: any = null;

  public estado: ProposalState | null;
  public descripcionUltimoMovimiento: string | null;
  public razonUltimoMovimiento: string | null;

  public isHistoricalProject?: boolean;
  public totalBudgetHistory?: number;
  public fondocytContribution?: number;
  public totalDisbursedToDate?: number;
  public totalCounterPart?: number;
  public pendingDisbursement?: number;
  public endProyectDate?: Date | null;

  public projectState?: ProjectState = ProjectState.InHold;


  // UI VARIABLES

  public executiveSummaryUI: any = "";
  public executiveSummaryWordsCounterUI: string = null;
  public abstractUI: string = null;
  public introductionUI: string = null;
  public researchProblemUI: string = null;
  public objetivesUI: string = null;
  public justificationUI: string = null;
  public backgroundUI: string = null;
  public stateOfTheArtUI: string = null;
  public methodsAndMaterialsUI: string = null;
  public personalInvolveProposalUI: string = null;
  public institutionDescriptionUI: string = null;
  public researchQuestionsUI: string = null;
  public hypothesisUI: string = null;
  public otherActorsUI: string = null;
  public bibliographyUI: string = null;

  constructor() {
    super();
    this.init();
  }

  init() {
    this.name = "";
    this.code = "";
    this.isOpenProject = false;
    this.codeProjectInExecution = null;
    this.annoucementId = 0;
    this.projectTypeId = null;
    this.areaId = null;
    this.fieldAreaId = null;
    this.researchLineId = null;
    this.documentContratId = null;
    this.resolveAnyProblem = false;
    this.isInternactionalCompany = false;
    this.researchLineOrInnovationType = null;
    this.modality = null;
    this.expectedResult = null;
    this.startDate = null;
    this.endDate = null;
    this.sendDateToIES = null;
    this.periodMonth = null;
    this.researchCenterId = null;
    this.aportFondocyt = 0;
    this.aportContrapartida = 0;
    this.totalBudget = undefined;
    this.executiveSummary = "";
    this.abstract = null;
    this.introduction = null;
    this.researchProblem = null;
    this.objetives = null;
    this.justification = null;
    this.background = null;
    this.stateOfTheArt = null;
    this.descripction = null;
    this.researchQuestions = null;
    this.hypothesis = null;
    this.methodsAndMaterials = null;
    this.institutionDescription = null;
    this.personalInvolveProposal = null;
    this.proposalScheduleGanttPhases = [];
    this.otherActors = null;
    this.bibliography = null;
    this.porposalMembers = [];
    this.proposedConsortiums = [];
    this.proposalDocuments = [];
    this.userWithoutCodes = [];
    this.userThatExcedTheCondition = [];
    this.coinId = 0;
    this.proposedConsortiumId = 0;
    this.aportFondocytBind = "";
    this.aportContrapartidaBind = "";
    this.proposalArticulatedDescripction = "";
    this.proposalArticulatedPosibleName = "";
    this.porposalBudgetItems = [];
    this.proposalMovements = [];
    this.especificObjectives = [];
    this.researchCenter = false;
    this.isOtros = false;
    this.isPatente = false;
    this.isPublicacionesVista = false;
    this.isOtrasPublicaciones = false;
    this.specificGoal = "";
   this.multipleWaitinResult = new MultipleWaitinResult()
    this.coin = new Coin();
    this.researchLineDescription = null;
    this.termsAndConditionsDescription = null;
    this.estado = null;
    this.descripcionUltimoMovimiento = null;
    this.razonUltimoMovimiento = null;
  }
}
